import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import globalState from '../../shared/globalState'
import AuthPrompt from '../AuthPrompt/AuthPrompt'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
}

export default function InfoModal() {
  const [open, setOpen] = useState(globalState.getState('infoModal') || false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const unsubscribe = globalState.subscribe((key, value) => {
    if (key === 'infoModal') {
      setOpen(value)
    }
  })
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Информация
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <AuthPrompt />
          </Typography>
        </Box>
      </Modal>
    </div>
  )
}
